import "what-input";
import a11y from "./components/a11y";

import domready from "./vendors/domready.js";
import targetBlankAdder from "./libs/target-blank-adder";
import video from "./components/video";
/* import svg from "./components/svg"; */
import wordSlider from "./components/word-slider/word-slider";

domready(() => {
  targetBlankAdder();
  video();
  a11y();
  wordSlider();
});
